import {
  MdListAlt,
  MdAdminPanelSettings,
  MdApartment,
  MdBusiness,
  MdCardMembership,
  MdCategory,
  MdChat,
  MdDashboard,
  MdDashboardCustomize,
  MdEditDocument,
  MdDescription,
  MdEmail,
  MdFactCheck,
  MdGppBad,
  MdGroup,
  MdHealing,
  MdKey,
  MdLocalHospital,
  MdLocationOn,
  MdManageSearch,
  MdMonitor,
  MdAttachMoney,
  MdPayments,
  MdPeople,
  MdReceiptLong,
  MdRequestQuote,
  MdSettings,
  MdShield,
  MdSupportAgent,
  MdTune,
  MdUploadFile,
  MdVolunteerActivism,
  MdWork,
} from "react-icons/md";
import { RiRobot3Line } from "react-icons/ri";
import { APPRoutes } from "./Route";
import { PermissionCodes } from "./Permissions";

const NAV = [
  {
    id: 1,
    label: "Dashboard",
    icon: <MdDashboard size={20} />,
    description: "Track platform health, KPIs, and operational summaries in one place.",
    page: APPRoutes.DASHBOARD,
    permission: PermissionCodes.DASHBOARD_VIEW,
  },
  {
    id: 2,
    label: "Clients",
    icon: <MdDashboardCustomize size={20} />,
    description: "Manage organizations, access setup, and client lifecycle details.",
    page: APPRoutes.CLIENTS,
    permission: PermissionCodes.CLIENTS_LIST,
    permissions: [
      PermissionCodes.CLIENTS_LIST,
      PermissionCodes.CLIENTS_VIEW,
      PermissionCodes.CLIENTS_CREATE,
      PermissionCodes.CLIENTS_EDIT,
      PermissionCodes.CLIENTS_DELETE,
    ],
    fallbackRoutes: [
      { permission: PermissionCodes.CLIENTS_VIEW, page: APPRoutes.CLIENTS_VIEW },
      { permission: PermissionCodes.CLIENTS_CREATE, page: APPRoutes.CLIENTS_FORM },
    ],
  },
  {
    id: 28,
    label: "Entity",
    icon: <MdWork size={20} />,
    description: "Manage entities including organizations, locations, and providers.",
    permissions: [
      PermissionCodes.ORGANIZATIONS_LIST,
      PermissionCodes.ORGANIZATIONS_VIEW,
      PermissionCodes.ORGANIZATIONS_CREATE,
      PermissionCodes.ORGANIZATIONS_EDIT,
      PermissionCodes.ORGANIZATIONS_DELETE,
      PermissionCodes.LOCATIONS_LIST,
      PermissionCodes.LOCATIONS_VIEW,
      PermissionCodes.LOCATIONS_CREATE,
      PermissionCodes.LOCATIONS_EDIT,
      PermissionCodes.LOCATIONS_DELETE,
      PermissionCodes.PROVIDERS_LIST,
      PermissionCodes.PROVIDERS_VIEW,
      PermissionCodes.PROVIDERS_CREATE,
      PermissionCodes.PROVIDERS_EDIT,
      PermissionCodes.PROVIDERS_DELETE,
      PermissionCodes.STAFFS_LIST,
      PermissionCodes.STAFFS_VIEW,
      PermissionCodes.STAFFS_CREATE,
      PermissionCodes.STAFFS_EDIT,
      PermissionCodes.STAFFS_DELETE,
      PermissionCodes.INCENTIVE_CONFIG_LIST,
      PermissionCodes.INCENTIVE_CONFIG_VIEW,
      PermissionCodes.INCENTIVE_CONFIG_CREATE,
      PermissionCodes.INCENTIVE_CONFIG_EDIT,
      PermissionCodes.INCENTIVE_CONFIG_DELETE,
    ],
    children: [
      {
        label: "Organizations",
        icon: <MdBusiness size={17} />,
        page: APPRoutes.ORGANIZATIONS,
        permission: PermissionCodes.ORGANIZATIONS_LIST,
        permissions: [
          PermissionCodes.ORGANIZATIONS_LIST,
          PermissionCodes.ORGANIZATIONS_VIEW,
          PermissionCodes.ORGANIZATIONS_CREATE,
          PermissionCodes.ORGANIZATIONS_EDIT,
          PermissionCodes.ORGANIZATIONS_DELETE,
        ],
        fallbackRoutes: [
          { permission: PermissionCodes.ORGANIZATIONS_VIEW, page: APPRoutes.ORGANIZATIONS_VIEW },
          { permission: PermissionCodes.ORGANIZATIONS_CREATE, page: APPRoutes.ORGANIZATIONS_FORM },
        ],
      },
      {
        label: "Locations",
        icon: <MdLocationOn size={17} />,
        page: APPRoutes.LOCATIONS,
        permission: PermissionCodes.LOCATIONS_LIST,
        permissions: [
          PermissionCodes.LOCATIONS_LIST,
          PermissionCodes.LOCATIONS_VIEW,
          PermissionCodes.LOCATIONS_CREATE,
          PermissionCodes.LOCATIONS_EDIT,
          PermissionCodes.LOCATIONS_DELETE,
        ],
        fallbackRoutes: [
          { permission: PermissionCodes.LOCATIONS_VIEW, page: APPRoutes.LOCATIONS_VIEW },
          { permission: PermissionCodes.LOCATIONS_CREATE, page: APPRoutes.LOCATIONS_FORM },
        ],
      },
      {
        label: "Providers",
        icon: <MdHealing size={17} />,
        page: APPRoutes.PROVIDERS,
        permission: PermissionCodes.PROVIDERS_LIST,
        permissions: [
          PermissionCodes.PROVIDERS_LIST,
          PermissionCodes.PROVIDERS_VIEW,
          PermissionCodes.PROVIDERS_CREATE,
          PermissionCodes.PROVIDERS_EDIT,
          PermissionCodes.PROVIDERS_DELETE,
        ],
        fallbackRoutes: [
          { permission: PermissionCodes.PROVIDERS_VIEW, page: APPRoutes.PROVIDERS_VIEW },
          { permission: PermissionCodes.PROVIDERS_CREATE, page: APPRoutes.PROVIDERS_FORM },
        ],
      },
      {
        label: "Staffs",
        icon: <MdPeople size={17} />,
        page: APPRoutes.STAFFS,
        permission: PermissionCodes.STAFFS_LIST,
        permissions: [
          PermissionCodes.STAFFS_LIST,
          PermissionCodes.STAFFS_VIEW,
          PermissionCodes.STAFFS_CREATE,
          PermissionCodes.STAFFS_EDIT,
          PermissionCodes.STAFFS_DELETE,
        ],
        fallbackRoutes: [
          { permission: PermissionCodes.STAFFS_VIEW, page: APPRoutes.STAFFS_VIEW },
          { permission: PermissionCodes.STAFFS_CREATE, page: APPRoutes.STAFFS_FORM },
        ],
      },
      {
        label: "Config",
        icon: <MdTune size={17} />,
        page: APPRoutes.INCENTIVE_RATES,
        permission: PermissionCodes.INCENTIVE_CONFIG_LIST,
        permissions: [
          PermissionCodes.INCENTIVE_CONFIG_LIST,
          PermissionCodes.INCENTIVE_CONFIG_VIEW,
          PermissionCodes.INCENTIVE_CONFIG_CREATE,
          PermissionCodes.INCENTIVE_CONFIG_EDIT,
          PermissionCodes.INCENTIVE_CONFIG_DELETE,
        ],
        fallbackRoutes: [
          { permission: PermissionCodes.INCENTIVE_CONFIG_VIEW, page: APPRoutes.INCENTIVE_RATES },
        ],
      }
    ],
  },
  {
    id: 20,
    label: "Analytics",
    icon: <MdMonitor size={20} />,
    description: "Analytics and performance dashboards.",
    page: APPRoutes.ANALYTICS,
    permission: PermissionCodes.ANALYTICS_VIEW,
    permissions: [
      PermissionCodes.ANALYTICS_VIEW,
      PermissionCodes.ANALYTICS_ORGANIZATIONS_LIST,
      PermissionCodes.ANALYTICS_ORGANIZATIONS_VIEW,
      PermissionCodes.ANALYTICS_PATIENTS_LIST,
      PermissionCodes.ANALYTICS_PATIENTS_VIEW,
      PermissionCodes.ANALYTICS_PRODUCTIVITY_LIST,
      PermissionCodes.ANALYTICS_PRODUCTIVITY_VIEW,
    ],
    children: [
      {
        label: "Organization",
        icon: <MdApartment size={17} />,
        page: APPRoutes.ANALYTICS_ORGANIZATIONS,
        permission: PermissionCodes.ANALYTICS_ORGANIZATIONS_LIST,
        permissions: [
          PermissionCodes.ANALYTICS_ORGANIZATIONS_LIST,
          PermissionCodes.ANALYTICS_ORGANIZATIONS_VIEW,
        ],
        fallbackRoutes: [
          { permission: PermissionCodes.ANALYTICS_ORGANIZATIONS_VIEW, page: APPRoutes.ANALYTICS_ORGANIZATION_VIEW },
        ],
      },
      {
        label: "Patients",
        icon: <MdPeople size={17} />,
        page: APPRoutes.ANALYTICS_PATIENTS,
        permission: PermissionCodes.ANALYTICS_PATIENTS_LIST,
        permissions: [
          PermissionCodes.ANALYTICS_PATIENTS_LIST,
          PermissionCodes.ANALYTICS_PATIENTS_VIEW,
        ],
        fallbackRoutes: [
          { permission: PermissionCodes.ANALYTICS_PATIENTS_VIEW, page: APPRoutes.ANALYTICS_PATIENT_VIEW },
        ],
      },
      {
        label: "Productivity",
        icon: <MdWork size={17} />,
        page: APPRoutes.ANALYTICS_PRODUCTIVITY,
        permission: PermissionCodes.ANALYTICS_PRODUCTIVITY_LIST,
        permissions: [
          PermissionCodes.ANALYTICS_PRODUCTIVITY_LIST,
          PermissionCodes.ANALYTICS_PRODUCTIVITY_VIEW,
        ],
        fallbackRoutes: [
          { permission: PermissionCodes.ANALYTICS_PRODUCTIVITY_VIEW, page: APPRoutes.ANALYTICS_PRODUCTIVITY_VIEW },
        ],
      },
      {
        label: "Revenue",
        icon: <MdAttachMoney size={17} />,
        page: APPRoutes.ANALYTICS_REVENUE,
        permission: PermissionCodes.ANALYTICS_ORGANIZATIONS_LIST,
        permissions: [
          PermissionCodes.ANALYTICS_ORGANIZATIONS_LIST,
          PermissionCodes.ANALYTICS_ORGANIZATIONS_VIEW,
        ],
        fallbackRoutes: [
          { permission: PermissionCodes.ANALYTICS_ORGANIZATIONS_VIEW, page: APPRoutes.ANALYTICS_REVENUE_VIEW },
        ],
      },
    ],
  },
  {
    id: 25,
    label: "Value-Based Care",
    icon: <MdVolunteerActivism size={20} />,
    description: "Value-Based Care incentive-program analytics by insurance payer.",
    page: APPRoutes.VALUE_BASED_CARE,
    permission: PermissionCodes.VALUE_BASED_CARE_LIST,
    permissions: [PermissionCodes.VALUE_BASED_CARE_LIST, PermissionCodes.VALUE_BASED_CARE_VIEW],
    fallbackRoutes: [
      { permission: PermissionCodes.VALUE_BASED_CARE_VIEW, page: APPRoutes.VALUE_BASED_CARE },
    ],
  },
  {
    id: 27,
    label: "Aegis AI",
    icon: <RiRobot3Line size={20} />,
    description: "Client-scoped RAG document management, embeddable assist widget configuration, and internal AI chat.",
    permissions: [
      PermissionCodes.DOCUMENTS_LIST,
      PermissionCodes.DOCUMENTS_VIEW,
      PermissionCodes.DOCUMENTS_CREATE,
      PermissionCodes.DOCUMENTS_EDIT,
      PermissionCodes.DOCUMENTS_DELETE,
      PermissionCodes.AGENT_BUILDER_LIST,
      PermissionCodes.AGENT_BUILDER_VIEW,
      PermissionCodes.AGENT_BUILDER_CREATE,
      PermissionCodes.AGENT_BUILDER_EDIT,
      PermissionCodes.AGENT_BUILDER_DELETE,
      PermissionCodes.ASSIST_VIEW,
    ],
    children: [
      {
        label: "Knowledge",
        icon: <MdDescription size={17} />,
        page: APPRoutes.AEGIS_AI_DOCUMENTS,
        permission: [PermissionCodes.DOCUMENTS_LIST, PermissionCodes.DOCUMENTS_VIEW],
        permissions: [
          PermissionCodes.DOCUMENTS_LIST,
          PermissionCodes.DOCUMENTS_VIEW,
          PermissionCodes.DOCUMENTS_CREATE,
          PermissionCodes.DOCUMENTS_EDIT,
          PermissionCodes.DOCUMENTS_DELETE,
        ],
        fallbackRoutes: [
          { permission: PermissionCodes.DOCUMENTS_CREATE, page: APPRoutes.AEGIS_AI_DOCUMENTS_FORM },
        ],
      },
      {
        label: "Agent Builder",
        icon: <MdSupportAgent size={17} />,
        page: APPRoutes.AEGIS_AI_ASSIST,
        permission: [PermissionCodes.AGENT_BUILDER_LIST, PermissionCodes.AGENT_BUILDER_VIEW],
        permissions: [
          PermissionCodes.AGENT_BUILDER_LIST,
          PermissionCodes.AGENT_BUILDER_VIEW,
          PermissionCodes.AGENT_BUILDER_CREATE,
          PermissionCodes.AGENT_BUILDER_EDIT,
          PermissionCodes.AGENT_BUILDER_DELETE,
        ],
        fallbackRoutes: [
          { permission: PermissionCodes.AGENT_BUILDER_CREATE, page: APPRoutes.AEGIS_AI_ASSIST_FORM },
        ],
      },
      {
        label: "Assist",
        icon: <MdChat size={17} />,
        page: APPRoutes.AEGIS_AI_CHAT,
        permission: PermissionCodes.ASSIST_VIEW,
        permissions: [PermissionCodes.ASSIST_VIEW],
      },
    ],
  },
  {
    id: 29,
    label: "Fee Schedule AI",
    icon: <MdRequestQuote size={20} />,
    description: "Negotiated rate analytics from payer price transparency files.",
    page: APPRoutes.FEE_SCHEDULE_ANALYTICS,
    permission: PermissionCodes.FEE_SCHEDULE_ANALYTICS_LIST,
    permissions: [PermissionCodes.FEE_SCHEDULE_ANALYTICS_LIST, PermissionCodes.FEE_SCHEDULE_ANALYTICS_VIEW],
    fallbackRoutes: [
      { permission: PermissionCodes.FEE_SCHEDULE_ANALYTICS_VIEW, page: APPRoutes.FEE_SCHEDULE_ANALYTICS_VIEW },
    ],
  },
  {
    id: 14,
    label: "Coding AI",
    icon: <MdReceiptLong size={20} />,
    description: "Reads clinical documentation and suggests the most likely CPT procedure codes and ICD-10 diagnosis codes, ranked by confidence.",
    page: APPRoutes.CODING_AI,
    permission: PermissionCodes.CODING_AI_VIEW,
    permissions: [PermissionCodes.CODING_AI_VIEW],
  },
  {
    id: 18,
    label: "Login Credentials",
    icon: <MdKey size={20} />,
    description: "Manage login credentials and access details for accounts.",
    page: APPRoutes.LOGIN_CREDS,
    permission: PermissionCodes.LOGIN_CREDS_LIST,
    permissions: [
      PermissionCodes.LOGIN_CREDS_LIST,
      PermissionCodes.LOGIN_CREDS_VIEW,
      PermissionCodes.LOGIN_CREDS_EDIT,
      PermissionCodes.LOGIN_CREDS_CREATE,
      PermissionCodes.LOGIN_CREDS_DELETE,
    ],
    fallbackRoutes: [
      { permission: PermissionCodes.LOGIN_CREDS_VIEW, page: APPRoutes.LOGIN_CREDS_VIEW },
      { permission: PermissionCodes.LOGIN_CREDS_CREATE, page: APPRoutes.LOGIN_CREDS_FORM },
    ],
  },
  {
    id: 30,
    label: "Reports",
    icon: <MdDescription size={20} />,
    description: "Run AdvancedMD Unapplied Transactions reports for a login and period, delivered by email.",
    page: APPRoutes.REPORTS,
    permission: PermissionCodes.REPORTS_RUN,
    permissions: [PermissionCodes.REPORTS_RUN],
  },
  {
    id: 19,
    label: "Credentialing",
    icon: <MdLocalHospital size={20} />,
    description: "Manage provider credentialing workflows and payor relationships.",
    permissions: [
      PermissionCodes.HEALTHCARE_PAYOR_LIST,
      PermissionCodes.HEALTHCARE_PAYOR_VIEW,
      PermissionCodes.HEALTHCARE_PAYOR_CREATE,
      PermissionCodes.HEALTHCARE_PAYOR_EDIT,
      PermissionCodes.HEALTHCARE_PAYOR_DELETE,
      PermissionCodes.CREDENTIALING_TRACKING_LIST,
      PermissionCodes.CREDENTIALING_TRACKING_VIEW,
      PermissionCodes.CREDENTIALING_TRACKING_CREATE,
      PermissionCodes.CREDENTIALING_TRACKING_EDIT,
      PermissionCodes.CREDENTIALING_TRACKING_DELETE,
    ],
    children: [
      {
        label: "HealthCare Payor",
        icon: <MdCategory size={17} />,
        page: APPRoutes.HEALTHCARE_PAYOR,
        permission: PermissionCodes.HEALTHCARE_PAYOR_LIST,
        permissions: [
          PermissionCodes.HEALTHCARE_PAYOR_LIST,
          PermissionCodes.HEALTHCARE_PAYOR_VIEW,
          PermissionCodes.HEALTHCARE_PAYOR_CREATE,
          PermissionCodes.HEALTHCARE_PAYOR_EDIT,
          PermissionCodes.HEALTHCARE_PAYOR_DELETE,
        ],
        fallbackRoutes: [
          { permission: PermissionCodes.HEALTHCARE_PAYOR_VIEW, page: APPRoutes.HEALTHCARE_PAYOR_VIEW },
          { permission: PermissionCodes.HEALTHCARE_PAYOR_CREATE, page: APPRoutes.HEALTHCARE_PAYOR_FORM },
        ],
      },
      {
        label: "Monitoring",
        icon: <MdMonitor size={17} />,
        page: APPRoutes.CREDENTIALING_TRACKING,
        permission: PermissionCodes.CREDENTIALING_TRACKING_LIST,
        permissions: [
          PermissionCodes.CREDENTIALING_TRACKING_LIST,
          PermissionCodes.CREDENTIALING_TRACKING_VIEW,
          PermissionCodes.CREDENTIALING_TRACKING_CREATE,
          PermissionCodes.CREDENTIALING_TRACKING_EDIT,
          PermissionCodes.CREDENTIALING_TRACKING_DELETE,
        ],
        fallbackRoutes: [
          { permission: PermissionCodes.CREDENTIALING_TRACKING_VIEW, page: APPRoutes.CREDENTIALING_TRACKING },
          { permission: PermissionCodes.CREDENTIALING_TRACKING_CREATE, page: APPRoutes.CREDENTIALING_TRACKING_FORM },
        ],
      }
    ],
  },

  {
    id: 15,
    label: "Claim 360",
    icon: <MdShield size={20} />,
    description: "Verifies the eligiblity status, Claim submission of patients",
    permissions: [
      PermissionCodes.CLAIM_SUBMISSION_EDIT,
      PermissionCodes.CLAIM_SUBMISSION_DELETE,
      PermissionCodes.CLAIM_SUBMISSION_VIEW,
      PermissionCodes.CLAIM_SUBMISSION_CREATE,
      PermissionCodes.CLAIM_SUBMISSION_LIST,

      PermissionCodes.CLAIM_STATUS_CREATE,
      PermissionCodes.CLAIM_STATUS_EDIT,
      PermissionCodes.CLAIM_STATUS_DELETE,
      PermissionCodes.CLAIM_STATUS_VIEW,
      PermissionCodes.CLAIM_STATUS_LIST,

      PermissionCodes.ELIGIBILITY_VERIFICATION_CREATE,
      PermissionCodes.ELIGIBILITY_VERIFICATION_EDIT,
      PermissionCodes.ELIGIBILITY_VERIFICATION_DELETE,
      PermissionCodes.ELIGIBILITY_VERIFICATION_VIEW,
      PermissionCodes.ELIGIBILITY_VERIFICATION_LIST,
    ],

    children: [
      // {
      //   label: "Claim Submission",
      //   icon: <MdUploadFile size={17} />,
      //   page: APPRoutes.CLAIM_SUBMISSION,
      //   permission: PermissionCodes.CLAIM_SUBMISSION_LIST,
      //   permissions: [
      //     PermissionCodes.CLAIM_SUBMISSION_EDIT,
      //     PermissionCodes.CLAIM_SUBMISSION_DELETE,
      //     PermissionCodes.CLAIM_SUBMISSION_VIEW,
      //     PermissionCodes.CLAIM_SUBMISSION_CREATE,
      //     PermissionCodes.CLAIM_SUBMISSION_LIST,
      //   ],
      //   fallbackRoutes: [
      //     { permission: PermissionCodes.CLAIM_SUBMISSION_VIEW, page: APPRoutes.CLAIM_SUBMISSION_VIEW },
      //     { permission: PermissionCodes.CLAIM_SUBMISSION_EDIT, page: APPRoutes.CLAIM_SUBMISSION_FORM },
      //   ],
      // },
      {
        label: "Claim Status",
        icon: <MdEditDocument size={17} />,
        page: APPRoutes.CLAIM_STATUS,
        permission: PermissionCodes.CLAIM_STATUS_LIST,
        permissions: [
          PermissionCodes.CLAIM_STATUS_EDIT,
          PermissionCodes.CLAIM_STATUS_DELETE,
          PermissionCodes.CLAIM_STATUS_VIEW,
          PermissionCodes.CLAIM_STATUS_CREATE,
          PermissionCodes.CLAIM_STATUS_LIST,
        ],
        fallbackRoutes: [
          { permission: PermissionCodes.CLAIM_STATUS_VIEW, page: APPRoutes.CLAIM_STATUS_VIEW },
          { permission: PermissionCodes.CLAIM_STATUS_EDIT, page: APPRoutes.CLAIM_STATUS_FORM },
        ],
      },

      // Denied claims are claim status data, so the item shares the claim status permissions.
      {
        label: "Denial Management",
        icon: <MdGppBad size={17} />,
        page: APPRoutes.DENIAL_MANAGEMENT,
        permission: PermissionCodes.CLAIM_STATUS_LIST,
        permissions: [
          PermissionCodes.CLAIM_STATUS_VIEW,
          PermissionCodes.CLAIM_STATUS_LIST,
        ],
        fallbackRoutes: [
          { permission: PermissionCodes.CLAIM_STATUS_VIEW, page: APPRoutes.DENIAL_MANAGEMENT_VIEW },
        ],
      },

      {
        label: "Eligibility Verification",
        icon: <MdFactCheck size={17} />,
        page: APPRoutes.ELIGIBILITY_VERIFICATION,
        permission: PermissionCodes.ELIGIBILITY_VERIFICATION_LIST,
        permissions: [
          PermissionCodes.ELIGIBILITY_VERIFICATION_EDIT,
          PermissionCodes.ELIGIBILITY_VERIFICATION_DELETE,
          PermissionCodes.ELIGIBILITY_VERIFICATION_VIEW,
          PermissionCodes.ELIGIBILITY_VERIFICATION_CREATE,
          PermissionCodes.ELIGIBILITY_VERIFICATION_LIST,
        ],
        fallbackRoutes: [
          { permission: PermissionCodes.ELIGIBILITY_VERIFICATION_VIEW, page: APPRoutes.ELIGIBILITY_VERIFICATION_VIEW },
          { permission: PermissionCodes.ELIGIBILITY_VERIFICATION_EDIT, page: APPRoutes.ELIGIBILITY_VERIFICATION_FORM },
        ],
      },

      {
        label: "Insurance List",
        icon: <MdListAlt size={17} />,
        page: APPRoutes.INSURANCE_LIST,
        permission: PermissionCodes.ELIGIBILITY_VERIFICATION_LIST,
        permissions: [
          PermissionCodes.ELIGIBILITY_VERIFICATION_LIST,
          PermissionCodes.CLAIM_STATUS_LIST,
        ],
      },
    ]

  },




  {
    id: 3,
    label: "Users",
    icon: <MdAdminPanelSettings size={20} />,
    description: "Control user accounts, roles, and permissions across the platform.",
    page: APPRoutes.USERS,
    permission: PermissionCodes.USERS_LIST,
    permissions: [
      PermissionCodes.USERS_LIST,
      PermissionCodes.USERS_VIEW,
      PermissionCodes.USERS_CREATE,
      PermissionCodes.USERS_EDIT,
      PermissionCodes.USERS_DELETE,
    ],
    fallbackRoutes: [
      { permission: PermissionCodes.USERS_VIEW, page: APPRoutes.USERS_VIEW },
      { permission: PermissionCodes.USERS_CREATE, page: APPRoutes.USERS_FORM },
    ],
  },
  {
    id: 6,
    label: "Roles and Permissions",
    icon: <MdSettings size={20} />,
    description: "Control user roles, permission groups, and security boundaries.",
    page: APPRoutes.ROLES,
    permission: PermissionCodes.ROLES_LIST,
    permissions: [
      PermissionCodes.ROLES_LIST,
      PermissionCodes.ROLES_VIEW,
      PermissionCodes.ROLES_CREATE,
      PermissionCodes.ROLES_EDIT,
      PermissionCodes.ROLES_DELETE,
    ],
    fallbackRoutes: [
      { permission: PermissionCodes.ROLES_VIEW, page: APPRoutes.ROLES_VIEW },
      { permission: PermissionCodes.ROLES_CREATE, page: APPRoutes.ROLES_FORM },
    ],
  },
  {
    id: 7,
    label: "Email Templates",
    icon: <MdEmail size={20} />,
    description: "Create and manage reusable communication templates and notifications.",
    page: APPRoutes.EMAIL_TEMPLATES,
    permission: PermissionCodes.EMAIL_TEMPLATES_LIST,
    permissions: [
      PermissionCodes.EMAIL_TEMPLATES_LIST,
      PermissionCodes.EMAIL_TEMPLATES_CREATE,
      PermissionCodes.EMAIL_TEMPLATES_EDIT,
      PermissionCodes.EMAIL_TEMPLATES_DELETE,
    ],
    fallbackRoutes: [
      { permission: PermissionCodes.EMAIL_TEMPLATES_CREATE, page: APPRoutes.EMAIL_TEMPLATES_FORM },
    ],
  },
  {
    id: 9,
    label: "Subscription",
    icon: <MdCardMembership size={20} />,
    description: "Configure plans, billing subscriptions, and customer enrollments.",
    permissions: [
      PermissionCodes.SUBSCRIPTION_PLANS_LIST,
      PermissionCodes.SUBSCRIPTION_PLANS_VIEW,
      PermissionCodes.SUBSCRIPTION_PLANS_CREATE,
      PermissionCodes.SUBSCRIPTION_PLANS_EDIT,
      PermissionCodes.SUBSCRIPTION_PLANS_DELETE,
      PermissionCodes.SUBSCRIBERS_LIST,
      PermissionCodes.SUBSCRIBERS_VIEW,
      PermissionCodes.SUBSCRIBERS_CANCEL,
    ],
    children: [
      {
        label: "Manage Plans",
        icon: <MdPayments size={17} />,
        page: APPRoutes.SUBSCRIPTION_MANAGE_PLANS,
        permission: PermissionCodes.SUBSCRIPTION_PLANS_LIST,
        permissions: [
          PermissionCodes.SUBSCRIPTION_PLANS_LIST,
          PermissionCodes.SUBSCRIPTION_PLANS_VIEW,
          PermissionCodes.SUBSCRIPTION_PLANS_CREATE,
          PermissionCodes.SUBSCRIPTION_PLANS_EDIT,
          PermissionCodes.SUBSCRIPTION_PLANS_DELETE,
        ],
        fallbackRoutes: [
          { permission: PermissionCodes.SUBSCRIPTION_PLANS_VIEW, page: APPRoutes.SUBSCRIPTION_VIEW },
          { permission: PermissionCodes.SUBSCRIPTION_PLANS_CREATE, page: APPRoutes.SUBSCRIPTION_CREATE },
        ],
      },
      {
        label: "Subscribers",
        icon: <MdGroup size={17} />,
        page: APPRoutes.SUBSCRIPTION_SUBSCRIBERS,
        permission: PermissionCodes.SUBSCRIBERS_LIST,
        permissions: [
          PermissionCodes.SUBSCRIBERS_LIST,
          PermissionCodes.SUBSCRIBERS_VIEW,
          PermissionCodes.SUBSCRIBERS_CANCEL,
        ],
        fallbackRoutes: [
          { permission: PermissionCodes.SUBSCRIBERS_VIEW, page: APPRoutes.SUBSCRIPTION_SUBSCRIBER_VIEW },
        ],
      },
    ],
  },
  {
    id: 12,
    label: "Audit Logs",
    icon: <MdManageSearch size={20} />,
    description: "Review activity trails, changes, and compliance events.",
    page: APPRoutes.AUDIT_LOGS,
    permission: PermissionCodes.AUDIT_LOGS_LIST,
    permissions: [PermissionCodes.AUDIT_LOGS_LIST, PermissionCodes.AUDIT_LOGS_VIEW],
    fallbackRoutes: [
      { permission: PermissionCodes.AUDIT_LOGS_VIEW, page: APPRoutes.AUDIT_LOGS_VIEW },
    ],
  }

];
export default NAV;